function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.136 24c6.624 0 11.994-5.373 11.994-12S18.76 0 12.136 0C5.51 0 .14 5.373.14 12s5.37 12 11.995 12z",
  fill: "#13426B"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.136 24c6.624 0 11.994-5.373 11.994-12S18.76 0 12.136 0C5.51 0 .14 5.373.14 12s5.37 12 11.995 12z",
  fill: "#13426B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.136 24c6.624 0 11.994-5.373 11.994-12S18.76 0 12.136 0C5.51 0 .14 5.373.14 12s5.37 12 11.995 12z",
  fill: "url(#enhanced-background-check_svg__paint0_linear)",
  fillOpacity: 0.1
});

var _ref4 = /*#__PURE__*/React.createElement("mask", {
  id: "enhanced-background-check_svg__a",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 25,
  height: 24
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.136 24c6.624 0 11.994-5.373 11.994-12S18.76 0 12.136 0C5.51 0 .14 5.373.14 12s5.37 12 11.995 12z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.136 24c6.624 0 11.994-5.373 11.994-12S18.76 0 12.136 0C5.51 0 .14 5.373.14 12s5.37 12 11.995 12z",
  stroke: "#fff"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#enhanced-background-check_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.394
}, /*#__PURE__*/React.createElement("mask", {
  id: "enhanced-background-check_svg__b",
  maskUnits: "userSpaceOnUse",
  x: 6,
  y: 5,
  width: 25,
  height: 24
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.96 5.33l11.22 11.302-12.205 12.294L6.962 17.66C7.22 11.501 18.96 5.33 18.96 5.33z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#enhanced-background-check_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.21 19.21c5.063 0 9.166-4.134 9.166-9.232 0-5.1-4.103-9.232-9.165-9.232-5.062 0-9.165 4.133-9.165 9.232 0 5.098 4.103 9.232 9.165 9.232z",
  fill: "#000"
}))), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.51 5.117L12.286 4.07a1.022 1.022 0 0 0-.34 0L5.718 5.117c-.5.084-.866.52-.866 1.031v7.322c0 4.881 6.65 7.172 6.934 7.267a1.03 1.03 0 0 0 .656 0c.283-.095 6.935-2.386 6.935-7.267V6.148c0-.51-.367-.947-.867-1.031z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("mask", {
  id: "enhanced-background-check_svg__c",
  maskUnits: "userSpaceOnUse",
  x: 4,
  y: 4,
  width: 16,
  height: 17
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.51 5.117L12.286 4.07a1.022 1.022 0 0 0-.34 0L5.718 5.117c-.5.084-.866.52-.866 1.031v7.322c0 4.881 6.65 7.172 6.934 7.267a1.03 1.03 0 0 0 .656 0c.283-.095 6.935-2.386 6.935-7.267V6.148c0-.51-.367-.947-.867-1.031z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.326 10.064a.573.573 0 0 0-.164-.4l-.797-.802a.567.567 0 0 0-.797 0l-3.845 3.87L9 10.995a.567.567 0 0 0-.797 0l-.797.8a.573.573 0 0 0 0 .802l2.122 2.132.797.802a.566.566 0 0 0 .797 0l.797-.802 4.243-4.265a.573.573 0 0 0 .164-.4z",
  fill: "#E25829"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.164 24.188c3.35 0 8.148-.456 9.32-.573a.372.372 0 0 0 .326-.288l1.373-6a.376.376 0 0 0-.395-.459c-1.73.135-7.443.56-10.624.56-3.271 0-8.909-.424-10.623-.559a.375.375 0 0 0-.395.459l1.372 5.999a.372.372 0 0 0 .326.288c1.173.117 5.98.573 9.32.573z",
  fill: "#00BD70"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.629 19.878l-.948-.145-.424-.902c-.017-.037-.05-.081-.093-.081s-.075.044-.092.081l-.425.902-.948.145c-.047.008-.105.032-.105.091 0 .036.024.07.047.096l.687.701-.162.992c-.002.014-.004.026-.004.04 0 .051.024.099.08.099.025 0 .05-.01.075-.024l.847-.468.848.468c.022.014.049.024.075.024.055 0 .077-.048.077-.1 0-.013 0-.025-.002-.04l-.162-.99.685-.702c.025-.026.05-.06.05-.096 0-.06-.061-.083-.106-.09z",
  fill: "#fff"
}));

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "enhanced-background-check_svg__paint0_linear",
  x1: 0.141,
  y1: 0,
  x2: 0.141,
  y2: 24,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.5
})));

var SvgEnhancedBackgroundCheck = function SvgEnhancedBackgroundCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default __webpack_public_path__ + "6e6ae8e414b961e4f9e86f8962ff040f.svg";
export { SvgEnhancedBackgroundCheck as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/enhanced-background-check.svg
// module id = null
// module chunks = 